import { useAuth } from '../contexts/AuthContext'
import { API_BASE_URL } from '../config'

// Talks to the pre-configured chat backend (POST /assistant/chat) — the
// backend keyword-matches against a fixed answer set, not a live LLM.
export const useAssistantService = () => {
  const { token, authFetch } = useAuth()

  const sendChatMessage = async (message: string): Promise<string> => {
    if (!token) {
      throw new Error('Not authenticated')
    }

    const response = await authFetch(`${API_BASE_URL}/assistant/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ message }),
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data?.error || `Failed to get a reply: ${response.status}`)
    }

    return data.reply
  }

  return { sendChatMessage }
}
